export const tr = {
    translation: {
        common: {
            trial: "Deneme Sürümü",
            expired: "Süresi Doldu",
            renewal: "Yenileme",
            quantity: "Adet",
            error: "Hata",
            all: "Tümü",
            loading: "Yükleniyor...",
            thank_you: "Teşekkürler",
            confirm: "Onayla",
            cancel: "Vazgeç",
            save: "Kaydet",
            add: "Ekle",
            edit: "Düzenle",
            delete: "Sil",
            warning: "Uyarı",
            delete_confirm_text: "Bu işlem geri alınamaz. Silmek istediğinize emin misiniz?",
            click_to_select: "Seçiniz...",
            unit: "Birim",
            detail: "Detay",
            done: "Tamam",
            search: "Ara",
            processing: "İşleniyor...",
            success: "Başarılı",
            total: "Toplam",
            none: "Yok",
            visible: "Görünür",
            hidden: "Gizli"
        },
        receipt: {
            info_slip: "BİLGİ FİŞİDİR",
            no_value: "MALİ DEĞERİ YOKTUR"
        },
        roles: {
            admin: "Yönetici",
            barista: "Barista",
            waiter: "Garson",
            kitchen: "Mutfak"
        },
        auth: {
            user_not_found: "Kullanıcı bulunamadı!",
            welcome: "Tekrar Hoşgeldiniz",
            subtitle: "Kahve dükkanınızı yönetmek için giriş yapın",
            google_login: "Google ile Giriş Yap",
            apple_login: "Apple ile Giriş Yap",
            secure_login: "Güvenli Giriş",
            terms_text: "Giriş yaparak Hizmet Şartlarımızı ve Gizlilik Politikamızı kabul etmiş olursunuz.",
            alerts: {
                google_failed: "Giriş başarısız. Lütfen tekrar deneyin.",
                restore_admin: "Acil Durum: Yönetici Rolünü Geri Yükle?",
                admin_success: "BAŞARILI: Kullanıcı '{{name}}' şimdi Yönetici ('{{role}}'). Lütfen giriş yapın.",
                no_staff: "HATA: Personel verisi henüz yüklenmedi. Lütfen biraz bekleyip tekrar deneyin."
            }
        },
        sidebar: {
            dashboard: "Panel",
            tables: "Masalar",
            staff: "Personel",
            loyalty: "CRM & Sadakat",
            qr_menu: "QR Menü",
            menu_product: "Menü & Ürünler",
            stock_recipe: "Stok & Reçete",
            reports: "Raporlar",
            settings: "Ayarlar",
            admin_panel: "Yönetici Paneli",
            not_logged_in: "Giriş Yapılmadı",
            click_to_select: "Profil Seçiniz",
            switch_profile: "Profil Değiştir",
            logout: "Çıkış Yap"
        },
        dashboard: {
            overview: "Panel Özeti",
            today: "Bugün",
            system_active: "Sistem Aktif",
            offline: "Çevrimdışı Mod",
            payment_reminder: "İşlem Hatırlatıcı",
            payment_missing_list: "{{names}} işlemi henüz yapılmadı.",
            add_expense: "Gider Ekle",
            daily_revenue: "Günlük Ciro",
            open_tables: "Açık Masalar",
            pending_tables: "Bekleyen Siparişler",
            waiting_approval: "Onay Bekleyen",
            active_staff: "Aktif Personel",
            hourly_revenue: "Saatlik Ciro",
            hourly_profit: "Saatlik Kar",
            work_hours: "Mesai Saatleri",
            hours_24: "24 Saat",
            revenue: "Ciro",
            profit: "Kar",
            best_sellers: "En Çok Satanlar",
            support_modal: { other: "Diğer" },
            weekly_performance: "Haftalık Performans",
            weekly_revenue: "Haftalık Ciro",
            increase: "Artış",
            decrease: "Azalış",
            busiest_day: "En Yoğun Gün",
            view_report: "Raporu Gör",
            critical_stock_warning: "Kritik Stok",
            quick_actions: "Hızlı İşlemler",
            x_report: "X Raporu",
            sync: "Senkronize Et",
            backup: "Yedekle",
            support: "Destek",
            help_support: "Yardım & Destek",
            help_desc: "Size nasıl yardımcı olabiliriz?",
            report_issue: "Sorun Bildir",
            version: "Sürüm",
            topic: "Konu",
            technical: "Teknik Sorun",
            suggestion: "Öneri",
            other: "Diğer",
            description: "Açıklama",
            desc_placeholder: "Lütfen sorunu açıklayınız...",
            send_report: "Raporu Gönder"
        },
        tables: {
            status: {
                occupied: "Dolu",
                paid: "Tamamlandı",
                reserved: "Rezerve",
                empty: "Boş"
            },
            alerts: {
                reservation_time: "Rezervasyon Saati:",
                draft_paid: "Tamamlanmış Taslak Sipariş",
                draft_unpaid: "Taslak Sipariş"
            },
            title: "Masa Planı",
            tabs: {
                plan: "Plan",
                history: "Geçmiş"
            },
            filter: {
                all: "Tümü"
            },
            actions: {
                finish_edit: "Düzenlemeyi Bitir",
                edit: "Masaları Düzenle",
                add_table: "Masa Ekle",
                quick_pay: "Hızlı İşlem",
                reserve: "Rezerve Et",
                clear: "Temizle"
            },
            card: {
                capacity: "Kişi",
                just_now: "Az önce",
                total: "Toplam",
                has_request: "Yeni İstek",
                no_order: "Sipariş Yok"
            },
            history: {
                search_placeholder: "Fiş No veya Masa Ara...",
                multi_pay: "Çoklu Ödeme"
            },
            sections: {
                manage: "Bölümleri Yönet",
                add_placeholder: "Yeni Bölüm Adı",
                no_sections: "Tanımlı bölüm yok."
            },
            modal: {
                edit_title: "Masa Düzenle",
                add_title: "Masa Ekle",
                name: "Masa Adı",
                name_placeholder: "Örn: Masa 5",
                section: "Bölüm",
                capacity: "Kapasite",
                delete: "Masayı Sil",
                unpaid_warning_title: "Tamamlanmamış Bakiye!",
                clear_confirm_title: "Masayı Temizle?",
                unpaid_warning_text: "<b>{{name}}</b> masasında tamamlanmamış bakiye var. Temizlemek siparişi sıfırlayacaktır.",
                clear_confirm_text: "<b>{{name}}</b> masasını temizlemek istediğinize emin misiniz?",
                delete_confirm_text: "<b>{{name}}</b> masasını silmek istediğinize emin misiniz?"
            },
            qr_review: {
                title: "Gelen QR Siparişi",
                subtitle: "{{name}} masasından yeni istek",
                current_state: "Mevcut Masa Durumu",
                table_empty: "Masa şu an boş.",
                current_total: "Mevcut Toplam",
                incoming_request: "Gelen İstek",
                extra_total: "Ekstra Tutar",
                reject: "Reddet",
                overwrite: "Üzerine Yaz",
                overwrite_desc: "Mevcudu sil & yenisini ekle",
                merge: "Birleştir",
                merge_desc: "Mevcuda ekle"
            }
        },
        orders: {
            status: {
                completed: "Tamamlandı"
            },
            list: {
                ticket_no: "Fiş No",
                date: "Tarih / Saat",
                table: "Masa / Müşteri",
                method: "Yöntem",
                amount: "Tutar",
                status: "Durum"
            },
            modal: {
                match_error: "Kayıt toplamı ({{pay}}₺) sipariş toplamı ({{total}}₺) ile eşleşmiyor.",
                title: "İşlem Detayı",
                content_title: "Sipariş İçeriği",
                total_title: "Toplam Tutar",
                payment_details: "Kayıt Detayları",
                entered_total: "Girilen Toplam",
                difference: "Fark"
            },
            correction: {
                note_placeholder: "Örn: Garson yanlış tuşladı"
            },
            void_flow: {
                button_update: "Durumu Güncelle / İptal",
                button_void: "İptal / İade İşlemleri",
                title_select: "İptal Türü Seçiniz",
                type_cancel: "Hatalı İşlem / İade",
                type_cancel_desc: "Stok Geri Yüklenir",
                type_wastage: "Zaiyat / Döküldü",
                type_wastage_desc: "Stok Düşer (İade Yok)",
                confirm_cancel_title: "Hatalı İşlem Olarak İşaretle",
                confirm_wastage_title: "Zaiyat Olarak İşaretle",
                confirm_cancel_text: "Bu işlem satışı iptal edecek ve kullanılan tüm stokları envantere geri yükleyecektir. Emin misiniz?",
                confirm_wastage_text: "Bu işlem satışı iptal edecek ancak stoklar KULLANILMIŞ sayılacaktır. Emin misiniz?",
                confirm: "ONAYLA"
            }
        },
        pos: {
            title_quick: "Hızlı İşlem",
            title_no_table: "Masa Yok",
            title_table: "{{name}}",
            search_placeholder: "Ürün Ara...",
            grid: {
                sold_out: "TÜKENDİ"
            },
            ticket: {
                title: "Operasyon",
                order_no: "SİPARİŞ NO",
                new: "YENİ",
                empty: "Sepet boş.",
                status: {
                    wastage: "ZAİYAT",
                    comp: "İKRAM",
                    cancelled: "İPTAL",
                    paid: "TAMAMLANDI"
                },
                discount_badge: "İND"
            },
            actions: {
                discount: "İNDİRİM",
                comp: "İKRAM",
                void: "ZAİYAT",
                cancel: "İPTAL",
                pay: "TAMAMLA",
                assign_table: "MASA",
                save: "KAYDET",
                waiting_payment: "İŞLEM BEKLİYOR",
                close_ticket: "BİTİR",
                transfer: "AKTAR",
                confirm_transfer: "AKTARIMI ONAYLA"
            },
            totals: {
                subtotal_net: "Ara Toplam (Net)",
                tax_vat: "Vergi (KDV)",
                grand_total: "Genel Toplam",
                tax_exclusive_hint: "(+Vergi)"
            },
            alerts: {
                table_not_found: "Masa bulunamadı.",
                perm_comp: "İkram verme yetkiniz yok.",
                perm_void: "Ürün iptal etme yetkiniz yok.",
                select_item_error: "Lütfen bir ürün seçin.",
                paid_item_error: "Tamamlanmış ürünler değiştirilemez.",
                split_quantity: "{{count}} adet üründen kaç tanesini ayırmak istersiniz?",
                invalid_amount: "Geçersiz miktar.",
                perm_discount: "İndirim yapma yetkiniz yok.",
                select_discount_item: "İndirim yapılacak ürünü seçin.",
                paid_discount_error: "Tamamlanmış ürünlere indirim yapılamaz.",
                add_items_first: "Lütfen önce sepete ürün ekleyin.",
                unauthorized: "Erişim Reddedildi",
                transfer_error_quick: "Hızlı siparişte ürün aktarımı yapılamaz.",
                no_financial_value: "Bu sayfada yapılan işlemin mali değeri yoktur"
            },
            modifier_modal: {
                no_modifiers: "Seçenek bulunmamaktadır.",
                multiple: "çoklu",
                add_to_cart: "Sepete Ekle"
            },
            discount_modal: {
                title: "İndirim Uygula",
                percent: "Yüzde",
                amount: "Tutar",
                comp_100: "İKRAM (%100)",
                old_total: "Eski Toplam",
                new_total: "Yeni Toplam",
                apply: "İndirimi Uygula"
            },
            transfer: {
                select_target: "Hedef Masa Seçin",
                merge: "BİRLEŞTİR",
                move: "TAŞI"
            }
        },
        payment: {
            alerts: {
                enter_valid: "Lütfen geçerli bir tutar giriniz.",
                balance_not_zero: "Fişi kapatmak için kalan bakiye 0 olmalıdır."
            },
            header_order: "Sipariş",
            header_open: "Aktif Operasyon",
            ticket_details: "Operasyon Detayları",
            select_all: "Tümünü Seç",
            items_count: "{{count}} Ürün",
            empty_list: "Ürün Yok",
            remaining_badge: "Kalan: {{amount}}",
            recent_transactions: "SON İŞLEMLER",
            totals: {
                total: "Toplam",
                paid: "İşlenen",
                remaining: "Kalan"
            },
            amount_to_collect: "Toplam",
            give_change: "Fark",
            return_to_customer: "İade",
            methods: {
                cash: "Nakit Kayıt",
                card: "Kredi Kartı Kayıt",
                qr: "QR / Mobil Kayıt",
                other: "Yemek Kartı Kayıt"
            },
            numpad: {
                all: "Hepsi"
            },
            actions: {
                cancel: "İptal",
                close_ticket: "Bitir",
                waiting_payment: "İşlem Bekliyor"
            }
        },
        menu: {
            title: "Menü Yönetimi",
            subtitle: "Ürünleri, fiyatları ve stoğu yönetin",
            add_new: "Ürün Ekle",
            edit_title: "Ürün Düzenle",
            add_title: "Ürün Ekle",
            manage_categories: "Kategorileri Yönet",
            alerts: {
                no_permission: "Menü yönetme yetkiniz yok.",
                delete_confirm: "Bu ürünü silmek istediğinize emin misiniz?"
            },
            form: {
                image_select: "Görsel Seç",
                image_change: "Görseli Değiştir",
                image_recommendation: "Kare format önerilir",
                image_max_size: "Maks 2MB",
                name: "Ürün Adı",
                name_placeholder: "Örn: Latte",
                category: "Kategori",
                price: "Fiyat",
                stock_tracking: "Stok Takibi",
                stock_hint: "Devre dışı bırakmak için 0 bırakın",
                description: "Açıklama",
                description_placeholder: "İçerik, detaylar...",
                customizable: "Özelleştirilebilir (Seçenekler)"
            },
            categories: {
                title: "Kategori Yönetimi",
                add: "Kategori Ekle",
                name: "Kategori Adı",
                edit: "Kategori Düzenle",
                delete_confirm: "Bu kategoriyi silmek istediğinize emin misiniz?"
            }
        },
        categories: {
            all: "Tümü",
            hot_coffees: "Sıcak Kahveler",
            cold_coffees: "Soğuk Kahveler",
            desserts: "Tatlılar",
            snacks: "Atıştırmalıklar",
            barista_special: "Özel"
        },
        stock: {
            title: "Envanter Yönetimi",
            subtitle: "Stok, Reçeteler ve Seçenekler",
            tabs: {
                inventory: "Envanter",
                recipes: "Reçeteler",
                modifiers: "Seçenekler"
            },
            inventory: {
                total_value: "Toplam Değer",
                sku_count: "Ürün Sayısı",
                alerts_header: "Stok Uyarıları",
                search_placeholder: "Stok Ara...",
                add_stock: "Ürün Ekle",
                status_critical: "Kritik",
                status_warning: "Az",
                status_sufficient: "Yeterli",
                table: {
                    name: "Ad",
                    supplier: "Tedarikçi",
                    amount: "Miktar",
                    status: "Durum",
                    unit_cost: "Birim Maliyet",
                    actions: "İşlemler"
                },
                modal: {
                    edit_title: "Stok Düzenle",
                    add_title: "Stok Ekle",
                    general_info: "Genel Bilgi",
                    management: "Yönetim",
                    name: "Ürün Adı",
                    name_placeholder: "Örn: Süt",
                    supplier: "Tedarikçi",
                    supplier_placeholder: "Örn: Yerel Çiftlik",
                    unit: "Birim",
                    alarm_thresholds: "Alarm Eşikleri",
                    warning_limit: "Uyarı Limiti",
                    critical_limit: "Kritik Limit",
                    stock_status: "Stok Durumu",
                    finish_editing: "Düzenlemeyi Bitir",
                    manual_correction: "Manuel Düzeltme",
                    current_amount: "Mevcut Miktar",
                    unit_cost: "Birim Maliyet",
                    new_purchase: "Yeni Satın Alma / Giriş",
                    add_amount: "Miktar Ekle",
                    purchase_price: "Alış Fiyatı",
                    total: "Toplam",
                    unit_price: "Birim Fiyat",
                    success_feedback: "Güncellendi!",
                    calculate_add: "Hesapla & Ekle",
                    avg_cost_note: "* Ağırlıklı ortalama maliyet hesaplar."
                },
                alerts_title: "Uyarılar",
                alerts: {
                    invalid_amount: "Lütfen geçerli bir miktar giriniz.",
                    ingredient_exists: "Bu malzeme zaten reçetede var. Miktarını güncellemek için listedeki öğeye çift tıklayın."
                }
            },
            wastage: {
                title: "Zaiyat Bildir",
                subtitle: "{{name}} için zaiyat bildirimi",
                amount: "Miktar",
                reason: "Sebep",
                reason_placeholder: "Örn: Döküldü, Bozuldu",
                report: "Zaiyat Bildir"
            },
            recipes: {
                search_product: "Ürün ara...",
                gross_margin: "Brüt Kar",
                sale_price: "Satış Fiyatı",
                cost_price: "Maliyet",
                ingredients: "İçindekiler",
                no_recipe: "Reçete tanımlanmamış.",
                add_ingredient: "Malzeme Ekle",
                stock_item: "Stok Ürünü",
                amount: "Miktar",
                unit: "Birim",
                select_product: "Listeden bir ürün seçin",
                edit_title: "Reçete Düzenle"
            },
            modifiers: {
                title: "Seçenek Grupları",
                new_group: "Yeni Grup",
                group_name: "Grup Adı",
                selection_type: "Seçim Tipi",
                single: "Tekli (Radyo)",
                multiple: "Çoklu (Onay Kutusu)",
                options: "Seçenekler",
                option_name: "Seçenek Adı",
                option_placeholder: "Örn: Yulaf Sütü",
                extra_price: "Ekstra Fiyat",
                deduct_stock: "Stoktan Düş",
                add_option: "Seçenek Ekle",
                group_helper_text: "Bu grup için seçenekleri aşağıdan yönetin.",
                no_link: "Bağlantı Yok",
                stock_optional_label: "Stok (Opsiyonel)",
                edit_group_title: "Grubu Düzenle",
                allow_multiple_label: "Çoklu seçime izin ver (Onay Kutusu)",
                delete_group_confirm: "Bu grubu silmek istediğinize emin misiniz?",
                select_group_hint: "Soldan bir grup seçin veya yeni oluşturun",
                edit_option_title: "Seçenek Düzenle",
                creating_group: "Yeni Grup Oluşturuluyor...",
                no_options: "Henüz seçenek eklenmemiş."
            }
        },
        reports: {
            title: "Finansal Özet",
            filters: { today: "Bugün", week: "Hafta", month: "Ay", all: "Tümü" },
            kpi: {
                revenue: "Toplam Ciro",
                net_revenue: "Net Ciro (Vergisiz)",
                tax_collected: "Toplanan Vergi",
                income: "Gelir",
                expense: "Toplam Gider",
                expense_opr: "Operasyonel",
                expense_stock: "SMM",
                expense_wastage: "Zaiyat",
                profit: "Net Kar",
                profit_opr: "Faaliyet Karı",
                cash_in_hand: "Kasa Akışı",
                gross_profit: "Brüt Kar",
                tickets: "Toplam İşlem",
                sales_count: "Satış Adedi",
                expense_analysis: "Gider Analizi",
                profit_analysis: "Net Kar Analizi",
                available_in_standard: "Standart Pakette Mevcut",
                locked: "Kilitli"
            },
            toggles: {
                stock_cost: "Stok Maliyeti",
                wastage: "Zaiyat",
                operational: "Operasyonel Mod",
                net_revenue: "Net Ciro (Vergi)"
            },
            charts: {
                sales_title: "Satış Grafiği ({{currency}})",
                hourly: "Saatlik",
                daily: "Günlük",
                monthly: "Aylık",
                distribution: "Dağılım",
                category_breakdown: "Kategori Dağılımı",
                revenue_share: "Gelir Payı",
                no_data: "Veri yok.",
                tooltip_revenue: "Ciro: ",
                tooltip_net_revenue: "Net Ciro: ",
                tooltip_profit: "Kar: "
            },
            transactions: {
                title: "İşlem Geçmişi",
                count_listed: "{{count}} Kayıt Listelendi",
                table: {
                    ticket_no: "Fiş No",
                    date: "Tarih / Saat",
                    table: "Masa",
                    method: "Yöntem",
                    amount: "Tutar",
                    status: "Durum"
                },
                status: {
                    completed: "Tamamlandı",
                    cancelled: "İptal"
                },
                no_records: "Seçilen aralıkta işlem bulunamadı."
            },
            x_report: {
                title: "Anlık Kasa Raporu (X-Raporu)",
                total_cash: "Kasadaki Toplam Nakit",
                daily_tickets: "Günlük Fiş Sayısı",
                cancelled_trx: "İptal Edilen İşlemler",
                collections: "Tahsilatlar (Güncel)",
                shift_reports: "Personel Vardiya Raporları (Bugün)",
                no_shift: "Henüz vardiya raporu yok.",
                total_sales: "TOPLAM SATIŞ",
                cash: "Nakit",
                credit_card: "Kredi Kartı",
                qr_mobile: "QR / Mobil",
                meal_card: "Yemek Kartı"
            },
            z_report: {
                title: "Gün Sonu Raporu (Z-Raporu)",
                auto_toggle: "Otomatik Z-Raporu",
                auto_desc: "Saat 00:00'da",
                close_button: "GÜNÜ KAPAT (Z-RAPORU)",
                history_title: "Geçmiş Z-Raporları",
                no_reports: "Henüz rapor yok.",
                receipt: {
                    title: "Z RAPORU",
                    report_no: "Rapor No",
                    cashier: "Kasiyer",
                    total_sales: "TOPLAM SATIŞ",
                    tax_base: "Vergi Matrahı",
                    total_tax: "Toplam Vergi",
                    payment_details: "Kayıt Detayları",
                    cash: "Nakit",
                    card: "Kredi Kartı",
                    other: "Diğer",
                    end: "--- SON ---"
                }
            },
            modals: {
                close_confirm: {
                    title: "Günü Kapat?",
                    text: "Bu işlem <strong>{{count}}</strong> adet açık işlemi arşivleyecek ve resmi bir Z-Raporu oluşturacaktır. Geri alınamaz.",
                    cancel: "Vazgeç",
                    confirm: "Onayla & Kapat"
                },
                expense: {
                    title: "Hızlı Gider Ekle",
                    date: "Tarih",
                    category: "Kategori",
                    amount: "Tutar",
                    description: "Açıklama",
                    optional: "İsteğe bağlı...",
                    set_default: "Kategori için varsayılan yap",
                    last_trx: "Son: {{amount}} ({{date}})"
                },
                processing: {
                    title: "Z-Raporu Oluşturuluyor...",
                    text: "Lütfen bekleyin, gün sonu işlemi yapılıyor..."
                }
            },
            liabilities: {
                pending: "Bekleyen İşlemler",
                label_today: "Bugünün Gider Payı",
                label_week: "Haftalık Gider Payı",
                label_total: "Bekleyen Düzenli İşlemler"
            }
        },
        settings: {
            general: "Genel Ayarlar",
            titles: {
                general: "Genel",
                expenses: "Giderler",
                modifiers: "Seçenekler",
                developer: "Geliştirici"
            },
            descriptions: {
                general: "Sistem, dil ve işletme ayarları",
                expenses: "Finansal yapılandırma",
                developer: "Simülasyon ve test araçları"
            },
            subscription: {
                active: "AKTİF",
                inactive: "PASİF",
                expired: "SÜRESİ DOLDU",
                renew: "Yenile",
                days_left: "Gün Kaldı",
                next_payment: "Sonraki Ödeme",
                period_start: "Dönem Başı",
                time_remaining: "Kalan Süre",
                lite_plan: "Lite Paket",
                standard_plan: "Standart Paket"
            },
            business_identity: "İşletme Kimliği",
            financial: "Finansal Ayarlar",
            financial_desc: {
                currency_desc: "Sistem genelinde kullanılan sembol",
                pricing_desc: "Vergi hesaplama yöntemi"
            },
            interface: {
                title: "Arayüz",
                scale: "Arayüz Ölçeği (Zoom)",
                scale_desc: "Sığmayan veya küçük/büyük görünen öğeler için ölçeği ayarlayın.",
                note: "Not:",
                scale_note: "1366px'den küçük ekranlarda otomatik ölçeklendirme her zaman aktiftir."
            },
            navigation: {
                title: "Menü Görünümü",
                desc: "Sol menüde görünmesini istemediğiniz sayfaları buradan gizleyebilirsiniz."
            },
            operational: {
                title: "Çalışma Saatleri & Vardiya",
                start_hour: "Başlangıç Saati (0-23)",
                end_hour: "Bitiş Saati (0-23)",
                info_text: "Bu ayar, **Panel** sayfasındaki saatlik satış grafiğinde 'Mesai Saatleri' seçildiğinde gösterilecek zaman aralığını belirler. Ayrıca personel vardiya raporlamasında referans alınır.",
                updated_alert: "Çalışma saatleri güncellendi."
            },
            shortcuts: {
                staff_desc: "Garson, Barista ve Yöneticileri yönetin"
            },
            backup: {
                title: "Veri & Yedekleme",
                backup_now: "Yedekle",
                backup_desc: "Veritabanını İndir (.json)",
                restore: "Geri Yükle",
                restore_desc: ".json Dosyası Seç",
                factory_reset: "Fabrika Ayarları",
                reset_desc: "Tüm veriler silinecek ve başlangıç durumuna dönülecek.",
                reset_button: "Verileri Sıfırla",
                success_restore: "Yedek başarıyla geri yüklendi.",
                alerts: {
                    confirm_upload: "Yedek başarıyla yüklendi. Bu verileri Buluta yüklemek ve buluttaki verilerle eşitlemek ister misiniz? (Mevcut bulut verileri güncellenecektir)",
                    sync_started: "Bulut senkronizasyonu başlatıldı!",
                    confirm_download: "Buluttaki veriler indirilecek ve yerel verilerle birleştirilecek. Devam etmek istiyor musunuz?",
                    confirm_repair: "Sunucu bağlantısı onarılacak. Devam edilsin mi?",
                    repair_success: "Onarım başarılı! Sayfa yenileniyor...",

                    login_required: "Lütfen önce giriş yapın.",
                    force_upload_confirm: "Tüm yerel veriler buluta yüklenecek (Mevcut bulut verilerinin üzerine yazılır). Bu işlem geri alınamaz. Devam edilsin mi?"
                }
            },
            security: {
                reset_title: "Fabrika Ayarlarına Dön",
                restore_title: "Yedekten Geri Yükle",
                reset_text: "Bu işlem geri alınamaz. Tüm veriler (satışlar, ürünler, stok) kalıcı olarak silinecektir.",
                restore_text: "Mevcut veriler silinecek ve seçilen yedek dosyasındaki veriler yüklenecektir.",
                admin_required: "Yönetici Onayı Gerekli",
                enter_pin: "Lütfen PIN giriniz",
                confirm_reset: "Sil & Sıfırla",
                confirm_restore: "Geri Yüklemeyi Başlat"
            },
            messages: {
                updated: "Ayarlar güncellendi.",
                error: "Bir hata oluştu."
            },
            sync: {
                title: "Bulut Senkronizasyonu",
                pending: "{{count}} bekleyen işlem var",
                up_to_date: "Tüm veriler güncel",

                button: "Senkronize Et",
                force_upload: "Verileri Zorla Yükle",
                alerts: {
                    offline: "İnternet bağlantısı yok.",
                    prep_fail: "Upload hazırlığı başarısız oldu.",
                    download_error: "İndirme Hatası: ",
                    download_success: "Veriler indirildi:\n{{prods}} Ürün\n{{stocks}} Stok\n{{cats}} Kategori\n{{staff}} Personel\n{{trans}} İşlem (Geçmiş)\n{{z}} Z-Raporu",
                    sync_error: "Senkronizasyon Hatası: ",
                    pending_upload: "Lütfen önce bekleyen değişiklikleri gönderin (Sync Button).",
                    cafe_id_missing: "Cafe ID bulunamadı.",
                    setup_error: "Kurulum hatası: Cafe ID bulunamadı. Lütfen sayfayı yenileyin."
                }
            }
        },
        financials: {
            title: "Finansal Ayarlar",
            subtitle: "Vergi Oranları & Gider Kategorileri",
            tabs: {
                taxes: "Vergiler",
                expenses: "Giderler",
                history: "Gider Geçmişi"
            },
            taxes: {
                title: "Vergi Oranları",
                active_rates: "Aktif Oranlar",
                rate_name: "Oran Adı",
                rate_percent: "Oran %",
                description: "Açıklama",
                add_new: "Yeni Oran Ekle",
                category_mapping: "Kategori Vergi Eşleşmesi"
            },
            expenses: {
                title: "Gider Kategorileri",
                add_new: "Kategori Ekle",
                category_name: "Kategori Adı",
                description: "Açıklama",
                default_amount: "Varsayılan Tutar",
                recurring: "Düzenli (Aylık)",
                recurring_day: "Ayın Günü",
                distribute_daily: "Raporlarda Günlük Dağıt"
            },
            history: {
                title: "Gider Geçmişi",
                filter_all: "Tüm Kategoriler",
                no_records: "Kayıt bulunamadı.",
                table: {
                    date: "Tarih",
                    category: "Kategori",
                    description: "Açıklama",
                    amount: "Tutar"
                }
            }
        },
        crm: {
            title: "CRM & Sadakat",
            subtitle: "Müşteri Yönetimi & Sadakat Programı",
            give_points: "Puan Ver",
            qr_instruction: "Müşteri için QR kod okutun",
            generate_qr: "QR Oluştur",
            qr_description: "Bu QR kodu müşteriye göstererek cüzdanına puan ekleyebilirsiniz.",
            customer_list: "Müşteri Listesi",
            search_placeholder: "Müşteri Ara...",
            last_visit: "Son Ziyaret:",
            eligible: "Ödül Kazanıldı!",
            settings_title: "Kampanya Ayarları",
            target_points: "Hedef Puan",
            reward_name: "Ödül Adı",
            preview: "Kart Önizleme",
            target_label: "Hedef",
            coming_soon: "Çok Yakında",
            tab_customers: "MÜŞTERİLER",
            tab_loyalty: "SADAKAT PROGRAMI",
            add_customer: "Müşteri Ekle",
            edit_customer: "Müşteri Düzenle",
            form_name: "AD SOYAD",
            name_placeholder: "Örn: Ahmet Yılmaz",
            form_phone: "TELEFON",
            form_email: "E-POSTA",
            form_notes: "NOTLAR",
            total_spent: "TOPLAM HARCAMA",
            debt: "BAKİYE / BORÇ",
            no_customers: "Henüz müşteri kaydı bulunmamaktadır.",
            loyalty_desc_future: "Gelişmiş sadakat programı özellikleri, puan sistemi, kampanya yönetimi ve dijital kart entegrasyonları çok yakında hizmetinizde olacak.",
            alerts: {
                qr_failed: "QR Kod oluşturulamadı. İnternet bağlantınızı kontrol edin.",
                settings_updated: "Kampanya ayarları güncellendi."
            },
            customer_detail: "Müşteri Detayı",
            transactions: "İşlem Geçmişi",
            make_payment: "İşlem Al (Kayıt)",
            adjust_balance: "Bakiye Düzenle",
            add_debt: "Borç/Kayıt Ekle",
            payment_amount: "İşlem Tutarı",
            payment_method: "İşlem Yöntemi",
            new_balance: "Yeni Bakiye",
            current_debt: "Bakiye/Borç Durumu",
            confirm_adjustment: "Bakiye Güncelle",
            history_table: {
                date: "Tarih",
                type: "İşlem",
                amount: "Tutar",
                staff: "Personel"
            },
            trx_types: {
                order: "Sipariş",
                debt_payment: "Tahsilat",
                correction: "Düzeltme"
            }
        },
        qr: {
            title: "QR Menü",
            subtitle: "Dijital Menü & Sipariş Sistemi",
            simulate: "Sipariş Simüle Et",
            print_selected: "Seçilenleri Yazdır",
            lock: {
                title: "Online Hizmetler Kilitli",
                desc: "QR Menü ve online sipariş özellikleri Standart Paket ile kullanılabilir.",
                upgrade_btn: "Paketi Yükselt"
            },
            print: {
                title: "QR Kodları Yazdır",
                scan_instruction: "Menü İçin Okutunuz"
            },
            preview: {
                title: "Canlı Önizleme",
                network: "Ağ:",
                password: "Şifre:",
                powered_by: "KahveInn Altyapısı",
                disclaimer: "* Bu, QR standının nasıl görüneceğinin bir önizlemesidir.",
                scan_instruction: "Menü İçin Tara"
            },
            settings: {
                general: "Genel",
                active: "Aktif",
                active_desc: "QR Menü sistemini etkinleştir",
                ordering: "Sipariş İzni",
                ordering_desc: "Müşteriler sipariş verebilir",
                sound: "Sesli Bildirim",
                sound_desc: "Yeni siparişte ses çal",
                design: "Tasarım",
                header_text: "Başlık Metni",
                theme_color: "Tema Rengi",
                wifi_ssid: "Wi-Fi Adı",
                wifi_pass: "Wi-Fi Şifresi"
            },
            selection: {
                title: "Masa Seçimi",
                select_all: "Tümünü Seç",
                previewing: "Önizleniyor"
            },
            modal: {
                permission_title: "İzin Gerekli",
                permission_text: "Sesli bildirimleri çalabilmek için tarayıcı iznine ihtiyacımız var.",
                allow_btn: "Sese İzin Ver"
            },
            alerts: {
                audio_failed: "Ses çalınamadı. Lütfen tarayıcı ayarlarından ses izni verin.",
                simulation_req: "Simülasyon için en az bir masa ve ürün olmalıdır.",
                print_req: "Lütfen yazdırılacak masaları seçin."
            }
        },
        staff: {
            title: "Personel Yönetimi",
            subtitle: "Çalışanlar ve yetkilendirme",
            tabs: {
                list: "Personel Listesi",
                roles: "Roller ve İzinler"
            },
            lite_banner: {
                title: "Lite Paket",
                desc: "Gelişmiş personel yönetimi kısıtlıdır."
            },
            stats: {
                total: "Toplam Personel",
                on_duty: "Mesaide"
            },
            matrix: {
                person: "Personel"
            },
            auto_shift_report: "Otomatik Vardiya Raporu",
            modal: {
                add_title: "Personel Ekle",
                edit_title: "Personel Düzenle",
                delete: "Personeli Sil",
                name: "Ad Soyad",
                role: "Rol",
                pin: "Şifre (4-hane)",
                phone: "Telefon (İsteğe Bağlı)",
                status: "Durum",
                status_working: "Çalışıyor",
                status_off: "İzinli"
            },
            roles_tab: {
                title: "Roller",
                subtitle: "Rol izinlerini özelleştirin",
                permissions: "İzinleri",
                no_permissions: "İzin tanımlanmamış"
            },
            contact: "İletişim",
            status: {
                working: "Çalışıyor",
                offline: "Mesaide Değil"
            },
            permission_matrix: "Yetki Matrisi",
            no_pin_permission: "Şifreyi görme/değiştirme yetkisi yok",
            unauthorized_tooltip: "Bu kullanıcıyı düzenleyemezsiniz",
            alerts: {
                no_add_permission: "Personel ekleme yetkiniz yok.",
                no_edit_others: "Sadece kendi profilinizi düzenleyebilirsiniz.",
                no_edit_admin: "Yöneticileri sadece Yöneticiler düzenleyebilir.",
                no_delete_self: "Kendinizi silemezsiniz.",
                no_delete_permission: "Personel silme yetkiniz yok.",
                no_delete_admin: "Yöneticileri sadece Yöneticiler silebilir.",
                delete_confirm: "Bu personeli silmek istediğinize emin misiniz?",
                no_status_admin: "Yönetici durumunu sadece Yöneticiler değiştirebilir.",
                only_admin_roles: "Rol izinlerini sadece Yöneticiler değiştirebilir."
            }
        },
        permission_groups: {
            general: "Genel",
            sales: "Satış",
            management: "Yönetim"
        },
        permissions: {
            VIEW_FINANCIALS: { label: "Finansal Verileri Gör", description: "Ciro ve kar verilerine erişim" },
            VIEW_TABLES: { label: "Masaları Gör", description: "Masa planı ve siparişleri görme" },
            MANAGE_TABLES: { label: "Masaları Düzenle", description: "Masa ekleme, silme ve plan düzenleme" },
            MANAGE_MENU: { label: "Menüyü Yönet", description: "Ürün ekleme ve düzenleme" },
            MANAGE_STOCK: { label: "Stok Yönet", description: "Envanter kontrolü" },
            VIEW_REPORTS: { label: "Raporları Gör", description: "Rapor sayfalarına erişim" },
            MANAGE_STAFF: { label: "Personel Yönet", description: "Personel ekleme/çıkarma" },
            MANAGE_SETTINGS: { label: "Ayarları Yönet", description: "Sistem yapılandırması" },
            VOID_ITEM: { label: "Ürün İptal Et", description: "İptal veya zaiyat işlemi" },
            OFFER_COMP: { label: "İkram Ver", description: "Ücretsiz (ikram) verme yetkisi" },
            APPLY_DISCOUNT: { label: "İndirim Yap", description: "Siparişe indirim uygulama" },
            CLOSE_DAY: { label: "Günü Kapat", description: "Z-Raporu alma yetkisi" },
            VIEW_X_REPORT: { label: "X-Raporu Görüntüleme", description: "Anlık kasa raporunu görüntüleyebilir" },
            VIEW_Z_REPORT: { label: "Z-Raporu Görüntüleme", description: "Gün sonu kapanış raporlarını görüntüleyebilir" },
            VIEW_DETAILED_REPORT: { label: "Detaylı Rapor Görüntüleme", description: "Excel/Kâr-Zarar detaylı raporunu görüntüleyebilir" }
        },
        setup: {
            business_name: "İşletme Adı",
            business_address: "Adres",
            manager_name: "Yönetici Adı",
            manager_hint: "Yönetici profili için isminiz",
            staff_count: "Personel Sayısı",
            staff_hint: "Tahmini çalışan sayısı",
            currency: "Para Birimi",
            pricing_model: "Fiyatlandırma Modeli",
            tax_inclusive: "Vergi Dahil (KDV Dahil)",
            tax_exclusive: "Vergi Hariç (+KDV)",
            completing: "Kurulum Tamamlanıyor...",
            title_1: "Hoşgeldiniz",
            title_2: "Ekip & Yönetim",
            title_3: "Finansal Ayarlar",
            desc_1: "İşletme kimliğinizi oluşturalım.",
            desc_2: "Ekip yapınızı yapılandıralım.",
            desc_3: "Para birimi ve vergi tercihlerinizi seçin.",
            skip_dev: "Atla (Dev)",
            back: "Geri",
            next: "İleri",
            finish: "Kurulumu Bitir",
            placeholders: {
                business_name: "Örn: KahveInn",
                city: "Şehir (Örn: İstanbul)",
                district: "İlçe (Örn: Kadıköy)",
                address_detail: "Mahalle, Cadde, No...",
                manager_name: "Adınız Soyadınız"
            },
            errors: {
                business_name: "Lütfen işletme adı giriniz.",
                city: "Lütfen şehir giriniz.",
                district: "Lütfen ilçe giriniz.",
                address_detail: "Lütfen açık adres giriniz.",
                manager_name: "Lütfen yönetici adı giriniz.",
                staff_count: "Lütfen geçerli bir sayı giriniz."
            },
            currencies: {
                try: "Türk Lirası (₺)",
                usd: "$ - Amerikan Doları ($)",
                eur: "Euro (€)",
                gbp: "Sterlin (£)"
            },
            loading_text: "Sisteminiz hazırlanıyor, lütfen bekleyin.",
            alerts: {
                reg_fail: "Sunucu kaydı başarısız oldu, ancak yerel kurulum devam ediyor. İnternet bağlantınızı kontrol edin."
            }
        },
        login: {
            // ... existing items ... 
            alerts: {
                admin_restore_confirm: "Acil Durum: Yönetici Rolünü Geri Yükle?",
                admin_restore_success: "BAŞARILI: '{{name}}' kullanıcısı artık Yönetici. Lütfen giriş yapın.",
                no_staff_data: "HATA: Henüz personel verisi yüklenmedi. Lütfen biraz bekleyip tekrar deneyin.",
                login_failed: "Giriş başarısız. Lütfen tekrar deneyin."
            }
        },
        loyalty: {
            // ... existing items ...
            alerts: {
                qr_fail: "QR Kod oluşturulamadı. İnternet bağlantınızı kontrol edin.",
                campaign_updated: "Kampanya ayarları güncellendi."
            }
        },
        loading: {
            status: {
                starting: "Başlatılıyor...",
                init_db: "Veritabanı başlatılıyor...",
                seeding: "Varsayılan veriler yükleniyor...",
                refreshing: "Veriler güncelleniyor...",
                ready: "Hazır!"
            }
        },
        modifier: {
            // ... existing ...
            alerts: {
                delete_group_confirm: "Bu özellik grubunu silmek istediğinize emin misiniz?",
                delete_option_confirm: "Bu seçeneği silmek istediğinize emin misiniz?"
            }
        }
    }
};
